import NextImage, { ImageProps } from "next/image";
import { useMemo } from "react";

type Props = Pick<
  ImageProps,
  "src" | "alt" | "role" | "width" | "height" | "style" | "fill"
>;
function Image(props: Props) {
  const valid = useMemo(() => {
    const { src } = props;
    // Users can enter image urls in the wysiwyg.
    // If next/image is called with an invalid URL, it breaks not only the image but also the page render (at least on dev local).
    return (
      typeof src === "string" &&
      (src.startsWith("/") ||
        src.startsWith("http://") ||
        src.startsWith("https://"))
    );
  }, [props]);

  if (!valid) {
    return null;
  }

  return <NextImage {...props} />;
}

export default Image;
